import { Badge } from "@chakra-ui/react";

const BadgeQueueStatus = ({ status }) => {
    let color = "gray"
    let text = "ไม่ระบุ"

    if (status === 1) {
        color = "yellow"
        text = "รอทำสัญญา"
    } else if (status === 2) {
        color = "orange"
        text = "แจ้งนัดและรอทำสัญญา"
    } else if (status === 3) {
        color = "green"
        text = "สมบูรณ์"
    } else if (status === 4) {
        color = "red"
        text = "ยกเลิกคิว"
    } else if (status === 5) {
        color = "red"
        text = "สละสิทธิ"
    }

    return (
        <Badge colorScheme={color}>{text}</Badge>
    )
}

export default BadgeQueueStatus